import type { AnimationControls, Transition, Variants } from 'framer-motion';
import { motion } from 'framer-motion';

import { type AnimatedIconHandle, withAnimatedIcon } from './withAnimatedIcon';

type CopyIconRenderProps = {
  controls: AnimationControls;
  size: number;
};

const DEFAULT_TRANSITION: Transition = {
  type: 'spring',
  stiffness: 160,
  damping: 17,
  mass: 1,
};

const rectVariants: Variants = {
  normal: { translateY: 0, translateX: 0 },
  animate: { translateY: -3, translateX: -3 },
};

const pathVariants: Variants = {
  normal: { x: 0, y: 0 },
  animate: { x: 3, y: 3 },
};

const CopyIconRender = ({ controls, size }: CopyIconRenderProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <motion.rect
      width="14"
      height="14"
      x="8"
      y="8"
      rx="2"
      ry="2"
      variants={rectVariants}
      animate={controls}
      transition={DEFAULT_TRANSITION}
    />
    <motion.path
      d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
      variants={pathVariants}
      animate={controls}
      transition={DEFAULT_TRANSITION}
    />
  </svg>
);

export type CopyIconHandle = AnimatedIconHandle;

export const CopyIcon = withAnimatedIcon(CopyIconRender, 'CopyIcon');
